import { Component } from "@angular/core";

@Component({
  selector: "app-trees-and-shrubs-fall-notification",
  templateUrl: "./trees-and-shrubs-fall-notification.component.html",
  standalone: false,
})
export class TreesAndShrubsFallNotificationComponent {}
